import { render, staticRenderFns } from "./GHLReport.vue?vue&type=template&id=9c23b5f2"
import script from "./GHLReport.vue?vue&type=script&lang=js"
export * from "./GHLReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports